"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ListItemIcon_1 = __importDefault(require("../../../../../ListItemIcon"));
var ListItemText_1 = __importDefault(require("../../../../../ListItemText"));
var ListItemSecondaryAction_1 = __importDefault(require("../../../../../ListItemSecondaryAction"));
var ListItem_1 = __importDefault(require("../../../../../ListItem"));
var Icon_1 = __importDefault(require("../../../../../Icon"));
var IconButton_1 = __importDefault(require("../../../../../IconButton"));
var form_1 = require("../../../../context/form");
var props_1 = require("../../../../context/props");
var useStyles_1 = __importDefault(require("./useStyles"));
var Item = function (_a) {
    var file = _a.file, index = _a.index;
    var onDeleteFile = (0, form_1.useFormContext)().onDeleteFile;
    var isLoading = (0, props_1.usePropsContext)().isLoading;
    var classes = (0, useStyles_1.default)();
    return (react_1.default.createElement(ListItem_1.default, { disableGutters: true },
        react_1.default.createElement(ListItemIcon_1.default, null,
            react_1.default.createElement(Icon_1.default, { kind: "attachFile" })),
        react_1.default.createElement(ListItemText_1.default, { classes: { root: classes.listItemTextontainer }, primary: file.name }),
        react_1.default.createElement(ListItemSecondaryAction_1.default, null,
            react_1.default.createElement(IconButton_1.default, { kind: "close", onClick: function () { onDeleteFile(index); }, disabled: isLoading }))));
};
exports.default = Item;
